import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, tap } from 'rxjs/operators';
import { WebSocketService } from '../../../../client/app/server-communication/services/websocket.service';
import { WebSocketMessageType } from '../../../../model/web-socket-message';
import StatisticsActions from './statistics.action-types';

@Injectable()
export class StatisticsEffects {
    constructor(private readonly actions$: Actions, private readonly webSocketService: WebSocketService) {}

    requestStatistics$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(StatisticsActions.requestStatistics),
                map(action => action.locationContext),
                tap(locationContext => {
                    this.webSocketService.sendMessage(WebSocketMessageType.Statistics, { locationContext });
                })
            ),
        { dispatch: false }
    );
}
